import type { ContentItem } from '@apptus/esales-api';

export default function mapElevateAutocompleteLink(link: ContentItem) {
    return {
        Id: link.key,
        contentUrl: link.link,
        contentType: link.type,
        contentName: link.title,
    };
}
